/* The „Założyłem" box: board O's sunken list, shared by the outline and the draft. */

.assumptions {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-14px) var(--space-4);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-12px);
}

.assumptionsTitle {
  margin: var(--space-0);
  font-size: var(--fs-note);
  font-weight: var(--fw-medium);
  color: var(--text);
}

.assumptionList {
  display: flex;
  flex-direction: column;
  gap: var(--space-6px);
  list-style: none;
}

.assumption {
  display: grid;
  grid-template-columns: 14px minmax(0, 1fr);
  gap: var(--space-2);
  font-size: var(--fs-foot);
  line-height: var(--lh-relaxed);
  color: var(--text-2);
}

/* An automatic match: the line, and its quiet „Zmień" at the end, centred on the line. */
.pick {
  grid-template-columns: 14px minmax(0, 1fr) auto;
  align-items: center;
}

.dot {
  width: 5px;
  height: 5px;
  margin: var(--space-7px) var(--space-0) var(--space-0) var(--space-1);
  background: var(--text-3);
  border-radius: var(--radius-bar);
}

.assumptionsFoot {
  margin: var(--space-0);
  font-size: var(--fs-label);
  font-weight: var(--fw-regular);
  color: var(--text-2);
}

.pick .dot {
  margin-top: var(--space-0);
}
